import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { Newsletter } from "@/components/site/Newsletter";
import { OrderButton } from "@/components/site/OrderContext";
import { NAV, LINKS } from "@/content/site";
import { TEADM_STORES, telHref } from "@/content/locations";

const Col = ({ title, children }) => (
  <div>
    <p className="eyebrow mb-5 text-[#ffd23f]">{title}</p>
    <ul className="space-y-3 text-[15px] text-[#fff5e8]/85">{children}</ul>
  </div>
);

const StoreItem = ({ l }) => (
  <li>
    <Link to={`/locations/${l.slug}`} data-testid={`footer-loc-${l.slug}`} className="font-semibold text-[#fff5e8] hover:text-[#ffd23f]">{l.name}</Link>
    <span className="block text-sm text-[#fff5e8]/70">{l.street}, {l.city} · <a href={telHref(l.phone)} className="hover:text-[#ffd23f]">{l.phone}</a></span>
  </li>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[#1a0a10] pt-20 text-[#fff5e8]">
    <div className="wrap">
      <div className="grid gap-12 border-b border-white/10 pb-14 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo light testId="footer-logo" />
          <p className="mt-6 max-w-sm text-[#fff5e8]/80">Handcrafted milk teas, Vietnamese coffee and fruit blends across Northern Virginia.</p>
          <p className="eyebrow mt-10 mb-4 text-[#ffd23f]">Newsletter</p>
          <Newsletter source="footer" testId="footer-newsletter" />
          <div className="mt-6 flex gap-3">
            <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="grid h-11 w-11 place-items-center rounded-full bg-white/10 transition-colors hover:bg-[#ff2e63]"><Instagram className="h-5 w-5" /></a>
            <a href={LINKS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="grid h-11 w-11 place-items-center rounded-full bg-white/10 transition-colors hover:bg-[#ff2e63]"><Facebook className="h-5 w-5" /></a>
            <a href={`mailto:${LINKS.email}`} aria-label="Email" data-testid="footer-email-icon" className="grid h-11 w-11 place-items-center rounded-full bg-white/10 transition-colors hover:bg-[#ff2e63]"><Mail className="h-5 w-5" /></a>
          </div>
        </div>
        <div className="grid gap-10 sm:grid-cols-2 lg:col-span-8 lg:grid-cols-3">
          <Col title="Explore">
            {NAV.map((n) => <li key={n.to}><Link to={n.to} data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`} className="hover:text-[#ffd23f]">{n.label}</Link></li>)}
            <li><Link to="/careers" data-testid="footer-careers" className="hover:text-[#ffd23f]">Careers</Link></li>
            <li><a href={LINKS.giftCards} target="_blank" rel="noopener noreferrer" data-testid="footer-buy-gift-cards" className="hover:text-[#ffd23f]">Buy gift cards ↗</a></li>
          </Col>
          <Col title="TeaDM stores">{TEADM_STORES.map((l) => <StoreItem key={l.slug} l={l} />)}</Col>
          <Col title="Say hi">
            <li><a href={`mailto:${LINKS.email}`} data-testid="footer-email" className="break-all hover:text-[#ffd23f]">{LINKS.email}</a></li>
            <li className="pt-2"><OrderButton className="btn btn-berry" testId="footer-order-online-btn">Order online</OrderButton></li>
          </Col>
        </div>
      </div>
      <div className="flex flex-col gap-3 py-6 text-sm text-[#fff5e8]/70 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} TeaDM. All rights reserved.</p>
        <p>Boba and the Beat · Northern Virginia</p>
      </div>
    </div>
    <p aria-hidden className="pointer-events-none select-none whitespace-nowrap text-center font-display text-[19vw] font-extrabold leading-[0.78] tracking-tighter text-[#ff2e63]">TeaDM</p>
  </footer>
);
